import { render, staticRenderFns } from "./ReleasesPage.vue?vue&type=template&id=4c472c28"
import script from "./ReleasesPage.vue?vue&type=script&lang=js"
export * from "./ReleasesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports